import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, Divider } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useProfile } from '../contexts/ProfileContext';
import { useSearchParams } from 'react-router-dom';
import { isFamilyAdmin } from '../services/familyDocumentService';
import FamilyDocumentsTab from './Documents/FamilyDocumentsTab';
import FamilyVaultTab from './Documents/FamilyVaultTab';
import SharedWithMeTab from './Documents/SharedWithMeTab';
import FileExplorer from './shared/FileExplorer';

const Documents = () => {
  const { currentUser } = useAuth();
  const { profile } = useProfile();
  const [searchParams] = useSearchParams();

  const [viewMode, setViewMode] = useState(searchParams.get('tab') || 'personal');
  const [isAdmin, setIsAdmin] = useState(false);

  // Check if user is family admin
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (currentUser && profile?.familyCode) {
        const adminStatus = await isFamilyAdmin(profile.familyCode, currentUser.uid);
        setIsAdmin(adminStatus);
      }
    };
    checkAdminStatus();
  }, [currentUser, profile]);

  const handleViewChange = (event, newValue) => {
    setViewMode(newValue);
  };


  if (!currentUser) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Please sign in to access documents.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Documents</Typography>
      <Divider sx={{ my: 2 }} />

      <Tabs
        value={viewMode}
        onChange={handleViewChange}
        sx={{ mb: 3 }}
      >
        <Tab label="PERSONAL DOCUMENTS" value="personal" />
        <Tab label="FAMILY DOCUMENTS" value="familyDocuments" />
        <Tab label="VAULT" value="vault" />
        {isAdmin && <Tab label="FAMILY VAULT" value="familyVault" />}
        <Tab label="SHARED WITH ME" value="shared" />
      </Tabs>

      {viewMode === 'personal' && (
        <FileExplorer
          collectionType="documents"
          storageArea="personal"
          title="Personal Documents"
          viewMode="grid"
          allowMoveToVault={true}
        />
      )}

      {viewMode === 'familyDocuments' && (
        <FamilyDocumentsTab />
      )}

      {viewMode === 'vault' && (
        <FileExplorer
          collectionType="documents"
          storageArea="vault"
          title="Vault"
          viewMode="grid"
          requiresVaultAccess={true}
          allowMoveFromVault={true}
        />
      )}

      {viewMode === 'familyVault' && isAdmin && (
        <FamilyVaultTab />
      )}

      {viewMode === 'shared' && (
        <SharedWithMeTab />
      )}
    </Box>
  );
};

export default Documents;
